import classNames from 'classnames';
import { PropertyExplorerSectionHeading as theme } from 'legacy/css-modules';

const PropertyExplorerSectionHeading = ({
  children,
  className,
  dataHcName,
  ...props
}) => {
  return (
    <h3
      data-hc-name={dataHcName}
      {...props}
      className={classNames(theme.Heading, className)}
    >
      {children}
    </h3>
  );
};

export default PropertyExplorerSectionHeading;
